import React from 'react';
import { FadeIn } from './FadeIn';
import { EyeIcon, MoonIcon, ArrowDownIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <EyeIcon className="w-6 h-6" data-id="element-114" />,
    title: 'Detecta',
    desc: 'Usa la Escala Visual para encontrar la ventana de 15 minutos de tu bebé.'
  }, {
    icon: <MoonIcon className="w-6 h-6" data-id="element-115" />,
    title: 'Sincroniza',
    desc: 'Aplica el Ritual de Desconexión de 4 pasos para bajar los niveles de cortisol.'
  }, {
    icon: <ArrowDownIcon className="w-6 h-6" data-id="element-116" />,
    title: 'Transfiere',
    desc: 'Usa la técnica de bajada lateral para que tu bebé se quede dormido sin notar el cambio al colchón.'
  }];
  return <section className="py-20 px-6 max-w-4xl mx-auto" data-id="element-117">
      <FadeIn data-id="element-118">
        <h2 className="text-3xl sm:text-4xl text-center text-taupe mb-12" data-id="element-119">
          Cómo funciona
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-120">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-sage/20 z-0" data-id="element-121"></div>

        {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-122">
            <div className="flex flex-col items-center text-center" data-id="element-123">
              <div className="w-20 h-20 bg-white rounded-full shadow-md flex items-center justify-center text-sage mb-6 border-4 border-cream" data-id="element-124">
                {step.icon}
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-sage/10 w-full h-full" data-id="element-125">
                <div className="text-xs font-bold text-sage mb-2 uppercase tracking-widest" data-id="element-126">
                  Paso {index + 1}
                </div>
                <h3 className="font-serif text-2xl text-taupe mb-3" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-taupe/70" data-id="element-128">{step.desc}</p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}